import { INITIAL_SCRAPE_CREDITS } from "@signalist/shared-types";

import { User } from "@/pages/Public/pages/Login/schema/login";

import { ListSourceType } from "@/enum/list.enum";

import { CatalogTile, CatalogTileRequirement } from "../config/tileCatalog";

export interface CatalogAvailabilityContext {
	profiles?: User[];
	profilesWithLiSn?: User[];
	profilesWithAdminPermissions?: User[];
	websiteScrapeCredits?: number;
}

export interface CatalogDisabledState {
	disabled: boolean;
	disabledMessageKey?: string;
}

const needsLinkedinProfile = (tile: CatalogTile): boolean =>
	[ListSourceType.LI_PEOPLE, ListSourceType.LI_EVENTS, ListSourceType.LI_PROFILE_VISITS].includes(
		tile.listType
	);

/** Ordering a scrape needs the credits the API charges for the source's first scrape. */
export const isWebsiteScrapePurchaseRequired = (
	tile: CatalogTile,
	websiteScrapeCredits?: number
): boolean =>
	tile.requirements.includes(CatalogTileRequirement.WEBSITE_SCRAPE_CREDITS) &&
	websiteScrapeCredits !== undefined &&
	websiteScrapeCredits < INITIAL_SCRAPE_CREDITS;

export const getCatalogTileDisabledState = (
	tile: CatalogTile,
	context: CatalogAvailabilityContext
): CatalogDisabledState => {
	if (isWebsiteScrapePurchaseRequired(tile, context.websiteScrapeCredits)) {
		return {
			disabled: false,
			disabledMessageKey: "list.create.catalog.disabled.noWebsiteScrapeCredits",
		};
	}

	if (tile.listType === ListSourceType.LI_SN && context.profilesWithLiSn?.length === 0) {
		return { disabled: true, disabledMessageKey: "list.create.catalog.disabled.noSalesNavigator" };
	}

	if (needsLinkedinProfile(tile) && context.profiles?.length === 0) {
		return { disabled: true, disabledMessageKey: "list.create.catalog.disabled.noLinkedin" };
	}

	if (
		tile.listType === ListSourceType.LI_COMPANY_ACTIVITY &&
		context.profilesWithAdminPermissions?.length === 0
	) {
		return {
			disabled: true,
			disabledMessageKey: "list.create.catalog.disabled.noCompanyAdmin",
		};
	}

	return { disabled: Boolean(tile.disabled) };
};
